<script setup lang="ts">
import {ref} from "vue";
import AddRecordSectionForm from "components/dialog/record/inner/AddRecordSectionForm.vue";
import {AddRecordSection} from "@/types";

const addRecordSectionForm = ref<InstanceType<typeof AddRecordSectionForm>>();
const visible = ref(false);

const show = () => {
  visible.value = true;
}

const hide = () => {
  visible.value = false;
}

const onClose = () => {
  addRecordSectionForm.value?.reset()
}

const emit = defineEmits(['onSubmit', "onPreviewVideo"])

const onSubmit = (form: AddRecordSection) => {
  emit("onSubmit", form);
}

const onPreviewVideo = (videoId: string) => {
  emit("onPreviewVideo", videoId);
}

defineExpose({
  show, hide
})
</script>

<template>
  <el-dialog title="新增章节" width="50rem" align-center v-model="visible" @close="onClose">
    <add-record-section-form
        ref="addRecordSectionForm"
        @on-preview-video="onPreviewVideo"
        @on-submit="onSubmit" @on-close="hide"/>
  </el-dialog>
</template>

<style scoped>
</style>
